import * as React from 'react';
import styles from './index.less';
import FDivider from '@/components/FDivider';
// import FUpdate from '@/components/FIcons/FUpdate';
import FComponentsLib from '@freelog/components-lib';
import { FI18n } from '@freelog/tools-lib';
import FIcons from '@/components/FIcons';

interface FCoverFooterButtonsProps {
  buttons: {
    type:
      | ''
      | 'active'
      | 'edit'
      | 'delete'
      | 'resourceDetails'
      | 'objectDetails'
      | 'update'
      | 'cancelCollect';
    text?: string;
    /** 仍展示入口，不可点击 */
    disabled?: boolean;
    fn(): void;
  }[];
}

// const btnMap: any = ;

export function FCoverFooterButtons({ buttons }: FCoverFooterButtonsProps) {
  const ref_btnMap = React.useRef({
    active: {
      text: FI18n.i18nNext.tAuto('btn_activate_theme'),
      icon: <FIcons.FMappingRuleActive />,
    },
    edit: {
      // text: '编辑',
      text: FI18n.i18nNext.tAuto('resource_card_btn_edit'),
      icon: <FIcons.FEdit />,
    },
    resourceDetails: {
      // text: '资源详情',
      text: FI18n.i18nNext.tAuto('resource_card_btn_viewdetails'),
      icon: <FIcons.FFileSearch />,
    },
    objectDetails: {
      text: '对象详情',
      icon: <FIcons.FFileSearch />,
    },
    delete: {
      text: '删除',
      icon: <FIcons.FDelete />,
    },
    update: {
      // text: '更新',
      text: FI18n.i18nNext.tAuto('resource_card_btn_update'),
      icon: <FIcons.FUpdate />,
    },
    cancelCollect: {
      text: '取消收藏',
      icon: <FIcons.FCancelCollect />,
    },
  } as const);

  return (
    <div className={styles.FCoverFooterButtons}>
      <div style={{ width: 1 }} />
      {buttons
        .filter(({ type }) => {
          return type !== '';
        })
        .map(({ type, text, disabled, fn }, i) => {
          return (
            <React.Fragment key={i}>
              {i !== 0 && <FDivider />}
              <a
                className={disabled ? styles.disabled : undefined}
                aria-disabled={disabled || undefined}
                onClick={(e) => {
                  if (disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                  }
                  fn();
                }}
              >
                {type && ref_btnMap.current?.[type]?.icon}
                <div style={{ height: 4 }} />
                <span>
                  {text || (type && ref_btnMap.current?.[type]?.text)}
                </span>
              </a>
            </React.Fragment>
          );
        })}
      <div style={{ width: 1 }} />
    </div>
  );
}

export default FCoverFooterButtons;
